// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InfosBox, { InfosBoxType } from "@store/Library/Components/Toolkit/InfosBox";
import useCart from "@toolkit/Framework/Common/GoogleAnalytics/hooks/utilities/useCart";
import React, { FC } from "react";
import { css } from "styled-components";
import * as cssLinter from "css";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";

enum fields {
    infoVariant = "infoVariant",
    useSiteMessage = "useSiteMessage",
    overrideText = "overrideText",
    customCSS = "customCSS",
}

interface Props extends WidgetProps {
    fields: {
        [fields.infoVariant]: InfosBoxType;
        [fields.useSiteMessage]: boolean;
        [fields.overrideText]: string;
        [fields.customCSS]: string;
    };
}

const OrderApprovalDetailsHasBeenApproved: FC<Props> = ({
    fields: { infoVariant, useSiteMessage, overrideText, customCSS },
}) => {
    const cart = useCart();
    const isEditing = useShellContext()?.isEditing;
    const customCssWrapper = {
        css: css`
            ${customCSS}
        `,
    };
    const hasBeenApproved = cart?.status === "Processing";
    if (!hasBeenApproved && !isEditing) {
        return null;
    }
    const infoBoxText = useSiteMessage ? siteMessage("OrderApprovalDetails_AlreadyApproved") : overrideText;

    return (
        <StyledWrapper {...customCssWrapper}>
            <InfosBox type={infoVariant} className="approver-message">
                {infoBoxText}
            </InfosBox>
        </StyledWrapper>
    );
};

const defaultCustomCss = `
/* Wrapper element */
.approver-message {
}
/* Icon element */ 
.approver-message span {
}
/* Text element */
.approver-message > div {
}

`;
const widgetModule: WidgetModule = {
    component: OrderApprovalDetailsHasBeenApproved,
    definition: {
        allowedContexts: ["OrderApprovalDetailsPage"],
        displayName: "Has Been Approved",
        group: "Order Approval Details",
        icon: "Info",
        fieldDefinitions: [
            {
                name: fields.infoVariant,
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Success", value: "success" },
                    { displayName: "Warning", value: "warning" },
                    { displayName: "Error", value: "error" },
                    { displayName: "Info", value: "info" },
                ],
                defaultValue: "success",
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.useSiteMessage,
                displayName: "Use Site Message",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 2,
            },
            {
                name: fields.overrideText,
                displayName: "Custom Message",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 3,
                isVisible: ({ fields }) => !fields.useSiteMessage,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: { displayName: "Advanced", sortOrder: 2 },
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
